/* eslint-disable */
const $optinChannelPanel = $('.m-optin-channels');
const $optinConsentPanel = $('.m-optin-consent');
const errorClass = 'm-private-input--error';
const checkboxParentClass = '.m-private-input--checkbox';

const optinErrorContainer = '#optinErrorContainer';
const agreeToAllErrorContainer = '#agreeToAllErrorContainer';
const mobileErrorContainer = '#mobileErrorContainer';
const zipErrorContainer = '#zipErrorContainer';



function UncheckOptin() {
  $optinChannelPanel
  .find('input:checkbox')
  .prop('checked', false);
}

function HighlightError(domElement, errorClassCss) {
  if ($(domElement).is('div') && !$(domElement).hasClass('ultiFormInput')) {
    $(domElement).addClass(errorClassCss);
  }
}

function UnhighlightError(domElement, errorClassCss) {
  if ($(domElement).is('div') && !$(domElement).hasClass('ultiFormInput')) {
    $(domElement).removeClass(errorClassCss);
  }  
}

function ShowValidationError(domElement, errorMessage) {
  const $domElement = $(domElement);
  if ($domElement.length > 0) {
    $domElement.find('span').text(errorMessage);
    const hasErrorClass = $domElement.hasClass('m-desc-error--hide');
    if (hasErrorClass) {
      $domElement.removeClass('m-desc-error--hide');
    } else {
      $domElement.show();
    }

  }
}

function ClearValidationError(domElement) {
  $(domElement).hide();
}

function HandleGDPRValidationError(isConsentValid, isOptinValid, hasAgreedToAll) {
  ClearValidationError(optinErrorContainer);
  ClearValidationError(agreeToAllErrorContainer);

  if(!isConsentValid) {

    if(hasAgreedToAll) {
      ShowValidationError(optinErrorContainer, OCMS.dicoKeys.OptinConsentRequiredError);
    } else {
      ShowValidationError(agreeToAllErrorContainer, OCMS.dicoKeys.OptinAndPrivacyPolicyError);
    }
  } else {
    if (!isOptinValid) {
      ShowValidationError(optinErrorContainer, OCMS.dicoKeys.OptinChannelsRequired);
    }
    if (!hasAgreedToAll) {
      ShowValidationError(agreeToAllErrorContainer, OCMS.dicoKeys.PrivacyPolicyRequired);
    }
  }

}

function CheckForOptinConsent() {
  const hasConsentNotChecked = $optinConsentPanel.length === 0 || $optinConsentPanel.find('input:not(:checked)').length > 0;

  if ($optinChannelPanel.length > 0) {
    if (hasConsentNotChecked) {
      $optinChannelPanel.hide();
      UncheckOptin();
    } else {
      $optinChannelPanel.show();
    }
  }
}

function UpdateOptinConsent() {
  $optinConsentPanel
  .find('input:checkbox')
  .click(() => {
    CheckForOptinConsent();
  });
}

function ScrollToFirstErrorOccur(){
    // scrollTop error 
    if($('.ultimateform__form').length 
    && OCMS.GlobalVars.Brand === "occ" 
    && $('[data-id="myaccount"]').length){

      var $formContainerAccount = $('.ultimateform__form'); 
      var $widthScreenGap = $(window).width() > 767 ? 120 : 70

      $formContainerAccount.each(function(i){
          var  $this = $(this);
          
          if($this.find('.m-private-input').hasClass('m-private-input--error')){

              var $scrollTofirstMessage  = document.getElementsByClassName('m-private-input--error').item(0)
                  $('body, html').animate({
                      scrollTop : $($scrollTofirstMessage).offset().top - $widthScreenGap
                  }, 800)
          }else if($('#gdpr-error-message').hasClass('error') && !$('.m-private-input').hasClass('m-private-input--error')){

              $('body, html').animate({
                  scrollTop : $('#gdpr-error-message').offset().top - $widthScreenGap
              }, 800)
          }
      });
  }
}

function ValidateRelatedField() {
  ClearValidationError(zipErrorContainer);
  ClearValidationError(mobileErrorContainer);
  UnhighlightError($(mobileErrorContainer).prev(), 'error');

 const selectedOptinChannels =  $optinChannelPanel.find('input:checkbox').filter(':checked');
 
 if (typeof OCMS.currentForm === 'undefined')
  return;

 const currentForm = OCMS.UltimateForms.get(OCMS.currentForm.FormId);
 let isRelatedValid = true;

 if (OCMS.currentForm && selectedOptinChannels.length > 0) {
  const currentForm = OCMS.UltimateForms.get(OCMS.currentForm.FormId);

  $.each(selectedOptinChannels, (idx, cbk) => {
    const optinType = $(cbk).data('optin');
    if (optinType === 'sms') {
      if (currentForm.mobile() === '') {
        isRelatedValid = false;
        ShowValidationError(mobileErrorContainer, OCMS.dicoKeys.PhoneRequiredForOptin);
        HighlightError($(mobileErrorContainer).prev(), 'error');
      }
    } else if(optinType === 'dm') {
      if (currentForm.zip() === '' || currentForm.address() === '') {
        isRelatedValid = false;
        ShowValidationError(zipErrorContainer, OCMS.dicoKeys.AddressRequiredForOptin);
      }
    }
  });
  return isRelatedValid;
 }
 return true;
}

function ValidateOptin() {
  const canSelectOptinChannel = !$optinChannelPanel.is(':hidden');
  if (canSelectOptinChannel) {
    const checkboxes = $optinChannelPanel.find('input:checkbox');
    const checkedOptin = $(checkboxes).filter(':checked').length;

    if (checkedOptin === 0) {
      $.each(checkboxes, (idx, ckb) => {
        $(ckb).parent(checkboxParentClass).addClass(errorClass);
      });
      return false;
    } else {
      $.each(checkboxes, (idx, ckb) => {
        $(ckb).parent(checkboxParentClass).removeClass(errorClass);
      });

    }
  }
  return true;
}

function ValidateConsent() {
  const $checkboxes = $('.m-optin-consent').find('input:checkbox');
  const isConsentRequired = $checkboxes.first().hasClass('required');
  let isConsentValid = true;

  if (isConsentRequired === true) {
    $.each($checkboxes, (idx, chk) => {
      if (!$(chk).is(':checked')) {
        $(chk).parent('.m-private-input--checkbox').addClass(errorClass);
        isConsentValid = false;
      } else {
        $(chk).parent('.m-private-input--checkbox').removeClass(errorClass);
      }
    });
    return isConsentValid;
  }
  return true;
}

function AcceptConsents() {
  $optinConsentPanel.find('input:checkbox').prop('checked', true);
}

function InitializeCustomerOptin() {
  const checkedOptins = $optinChannelPanel.find('input:checkbox').filter(':checked');
  if (checkedOptins.length > 0) {
    AcceptConsents();
  }
}

$(document).ready(() => {
  ClearValidationError(optinErrorContainer);
  InitializeCustomerOptin();
  UpdateOptinConsent();
});

export {
  InitializeCustomerOptin,
  CheckForOptinConsent,
  UpdateOptinConsent,
  ValidateOptin,
  ValidateConsent,
  HandleGDPRValidationError,
  ValidateRelatedField, 
  ScrollToFirstErrorOccur
};



// WEBPACK FOOTER //
// ./js/common/molecule/optin-channels.js